import netsExtensionNav from './nets-extension-nav';

export default angular
  .module('app.extension-nav', [])
  .component('netsExtensionNav', netsExtensionNav);
